import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import customer_icon from "../../assets/icons/customer_icon.png";
// import ProgressBar from "./progressBar";
import globe_icon from "../../assets/icons/globe_icon.png";
import avatar from "../../assets/images/avatar.png";
import threeDots_icon from "../../assets/icons/threeDots_icon.png";
import ph_phone_call_light from "../../assets/icons/ph_phone_call_light.png";
import ph_whatsapp_logo_thin from "../../assets/icons/ph_whatsapp_logo_thin.png";
import documents_icon from "../../assets/icons/documents_icon.png";
import attachment_pin_icon from "../../assets/icons/attachment_pin_icon.png";
import filter_png from "../../assets/icons/filter_png.png";

const AdminCustomerHistory = () => {
  const [activeSection, setActiveSection] = useState("person");
  const [activeTasks, setActiveTasks] = useState("due");
  const [activeTab, setActiveTab] = useState("follow");

  const handleTabClick = (tab) => {
    setActiveSection(tab);
  };

  const handleTasksClick = (task) => {
    setActiveTasks(task);
  };
  return (
    <>
      <div>
        <div>
          <SearchBar categoryName="Customer History" />
        </div>
        <div className="ml-4">
          <div className="bg-[#FFF9E9] w-[95%] rounded-lg border border-[#E0E0E0] my-4">
            <div>
              <div className="flex p-4 relative">
                <img
                  src={filter_png}
                  alt="filter"
                  className="absolute right-0 top-0"
                />
                <div>
                  <img src={customer_icon} alt="customer icon" />
                </div>
                <div>
                  <div className="text-[18px] font-bold">
                    Shopper Stop
                    <span className="text-[#828282] text-[14px] italic font-normal">
                      (lead)
                    </span>
                  </div>
                  <div className="text-[#219653] text-[16px]">Active</div>
                </div>
              </div>
            </div>
            <hr />
            <div>
              <div className="bg-white mt-4 mx-4 rounded-lg">
                <p className="p-2 text-[12px] font-bold">
                  Lead Status
                  <span className="text-[#828282] font-normal ml-1">
                    20% completed
                  </span>
                </p>
                <div className="bg-[#EBF2FF] pb-1 rounded-b-lg">
                  <p className="text-[#828282] text-[14px] text-center pt-4 font-bold">
                    Verification
                  </p>
                  <div className=" h-3 bg-[#E0E0E0] mx-2 rounded-lg my-2 relative">
                    <div className="h-3 w-[30%] bg-blue-700 absolute rounded-lg"></div>
                  </div>

                  {/* <ProgressBar /> */}
                </div>
              </div>
              <p className="text-[#828282] text-[12px] italic ml-4 mt-4">
                Store selection
              </p>
              <div>
                <div className="flex mb-4">
                  <div className="bg-white flex w-full ml-4 rounded-3xl">
                    <img
                      src={globe_icon}
                      alt="globe icon"
                      className="object-contain w-8 overflow-hidden mx-2"
                    />
                    <select className="p-y border rounded w-full text-[#888888] text-[16] border-none">
                      <option value="mumbai" selected>
                        Mumbai
                      </option>
                      <option value="chennai">Chennai</option>
                      <option value="kolkata">Kolkata</option>
                      <option value="bangalore">Bangalore</option>
                    </select>
                  </div>
                  <div className="bg-white flex justify-center w-[2.3rem] items-center ml-2 rounded-md mr-3">
                    <p className="text-[30px] cursor-pointer">+</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-[#FFF9E9] w-[95%] rounded-lg border border-[#E0E0E0] my-4">
            <div className="flex text-[#49454F] text-[12px] justify-around h-10">
              <div
                className="flex flex-col justify-between pt-3 cursor-pointer"
                onClick={() => handleTabClick("person")}
              >
                <p
                  className={`${
                    activeSection === "person" ? "text-[#2F80ED]" : ""
                  } `}
                >
                  Contact Person
                </p>
                {activeSection === "person" ? (
                  <div
                    className={` h-1 bg-[#2F80ED] rounded-t-lg w-full`}
                  ></div>
                ) : null}
              </div>
              <div
                className="flex flex-col justify-between pt-3 cursor-pointer"
                onClick={() => handleTabClick("Agents")}
              >
                <p
                  className={`${
                    activeSection === "Agents" ? "text-[#2F80ED]" : ""
                  } `}
                >
                  Agents
                </p>
                {activeSection === "Agents" ? (
                  <div
                    className={` h-1 bg-[#2F80ED] rounded-t-lg w-full`}
                  ></div>
                ) : null}
              </div>
              <div
                className="flex flex-col justify-between pt-3 cursor-pointer"
                onClick={() => handleTabClick("Distributor")}
              >
                <p
                  className={`${
                    activeSection === "Distributor" ? "text-[#2F80ED]" : ""
                  } `}
                >
                  Distributor
                </p>
                {activeSection === "Distributor" ? (
                  <div
                    className={` h-1 bg-[#2F80ED] rounded-t-lg w-full`}
                  ></div>
                ) : null}
              </div>
              <div
                className="flex flex-col justify-between pt-3 cursor-pointer"
                onClick={() => handleTabClick("Address")}
              >
                <p
                  className={`${
                    activeSection === "Address" ? "text-[#2F80ED]" : ""
                  } `}
                >
                  Address
                </p>
                {activeSection === "Address" ? (
                  <div
                    className={` h-1 bg-[#2F80ED] rounded-t-lg w-full`}
                  ></div>
                ) : null}
              </div>
            </div>

            <hr />

            <div className="bg-white p-4">
              <div className="flex justify-between">
                <div className="flex items-center">
                  <p>{">"}</p>
                  <div className="w-10 object-contain mx-4">
                    <img src={avatar} alt="avatar" className="rounded-full " />
                  </div>
                  <div>
                    <p className="font-bold text-[16px]">
                      Praveen Sharma{" "}
                      <span className="italic font-normal">
                        (senior manager)
                      </span>
                    </p>
                    <p className="text-[#828282] text-[12px]">
                      Last interacted: 05 Oct 2023
                    </p>
                  </div>
                </div>
                <div className="cursor-pointer">
                  <img src={threeDots_icon} alt="three dots" />
                </div>
              </div>
            </div>

            {/* second row */}
            <div className="bg-white px-4 pb-4 rounded-lg">
              <div className="flex justify-between">
                <div className="flex items-center">
                  <p>{">"}</p>
                  <div className="w-10 object-contain mx-4">
                    <img src={avatar} className="rounded-full" alt="avatar" />
                  </div>
                  <div>
                    <p className="font-bold text-[16px]">
                      Praveen Sharma{" "}
                      <span className="italic font-normal">
                        (senior manager)
                      </span>
                    </p>
                    <p className="text-[#828282] text-[12px]">
                      Last interacted: 05 Oct 2023
                    </p>
                  </div>
                </div>
                <div className="cursor-pointer">
                  <img src={threeDots_icon} alt="three dots" />
                </div>
              </div>
            </div>
          </div>

          {/* Due tasks and All Tasks */}
          <div className="bg-[#FFF9E9] w-[95%] rounded-lg border border-[#E0E0E0] my-4">
            <div className="flex text-[#49454F] text-[12px] justify-around h-10">
              <div
                className="flex flex-col justify-between pt-3 cursor-pointer"
                onClick={() => handleTasksClick("due")}
              >
                <p
                  className={`${
                    activeTasks === "due" ? "text-[#2F80ED]" : ""
                  } `}
                >
                  Due Tasks
                </p>
                {activeTasks === "due" ? (
                  <div
                    className={` h-1 bg-[#2F80ED] rounded-t-lg w-full`}
                  ></div>
                ) : null}
              </div>
              <div
                className="flex flex-col justify-between pt-3 cursor-pointer"
                onClick={() => handleTasksClick("All")}
              >
                <p
                  className={`${
                    activeTasks === "All" ? "text-[#2F80ED]" : ""
                  } `}
                >
                  All Tasks
                </p>
                {activeTasks === "All" ? (
                  <div
                    className={` h-1 bg-[#2F80ED] rounded-t-lg w-full`}
                  ></div>
                ) : null}
              </div>
            </div>

            <hr />

            <div className="bg-white p-4 flex justify-center items-center flex-col">
              <div className="w-[80%] overflow-auto">
                <div className="flex w-full justify-between">
                  <div
                    className={`flex flex-col items-center  px-16 py-4 rounded-lg cursor-pointer ${
                      activeTab === "follow" ? "bg-[#E5F8FF]" : "bg-[#FAFAFA]"
                    }`}
                    onClick={() => setActiveTab("follow")}
                  >
                    <p className="font-bold text-[24px]">02</p>
                    <p className="text-[16px] text-[#91929E]">Follow Ups</p>
                  </div>
                  <div
                    className={`flex flex-col items-center  px-16 py-4 rounded-lg cursor-pointer ${
                      activeTab === "pending" ? "bg-[#E5F8FF]" : "bg-[#FAFAFA]"
                    }`}
                    onClick={() => setActiveTab("pending")}
                  >
                    <p className="font-bold text-[24px]">04</p>
                    <p className="text-[16px] text-[#91929E]">Pending Visits</p>
                  </div>
                  <div
                    className={`flex flex-col items-center  px-16 py-4 rounded-lg cursor-pointer ${
                      activeTab === "docs" ? "bg-[#E5F8FF]" : "bg-[#FAFAFA]"
                    }`}
                    onClick={() => setActiveTab("docs")}
                  >
                    <p className="font-bold text-[24px]">03</p>
                    <p className="text-[16px] text-[#91929E]">Send Docs</p>
                  </div>
                  <div
                    className={`flex flex-col items-center  px-16 py-4 rounded-lg cursor-pointer ${
                      activeTab === "sample" ? "bg-[#E5F8FF]" : "bg-[#FAFAFA]"
                    }`}
                    onClick={() => setActiveTab("sample")}
                  >
                    <p className="font-bold text-[24px]">03</p>
                    <p className="text-[16px] text-[#91929E]">sample Text</p>
                  </div>
                </div>
              </div>

              {/* First row */}
              <div className="flex justify-between w-full mt-4">
                <div className="flex items-center">
                  <div className="w-10 object-contain mx-4">
                    <img src={avatar} className="rounded-full" alt="avatar" />
                  </div>
                  <div>
                    <p className="font-bold text-[16px]">
                      Praveen Sharma{" "}
                      <span className="italic font-normal">
                        (senior manager)
                      </span>
                    </p>
                    <p className="text-[#828282] text-[12px]">
                      Last interacted: 05 Oct 2023
                    </p>
                  </div>
                </div>
                <div className="cursor-pointer">
                  <img src={ph_phone_call_light} className="w-8" alt="phone" />
                </div>
              </div>
            </div>

            {/* second row */}
            <div className="bg-white px-4 pb-4 rounded-lg w-full">
              <div className="flex justify-between">
                <div className="flex items-center">
                  <div className="w-10 object-contain mx-4">
                    <img src={avatar} className="rounded-full " alt="avatar" />
                  </div>
                  <div>
                    <p className="font-bold text-[16px]">
                      Praveen Sharma{" "}
                      <span className="italic font-normal">
                        (senior manager)
                      </span>
                    </p>
                    <p className="text-[#828282] text-[12px]">
                      Last interacted: 05 Oct 2023
                    </p>
                  </div>
                </div>
                <div className="cursor-pointer">
                  <img
                    src={ph_whatsapp_logo_thin}
                    className="w-8"
                    alt="whatsapp"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className=" w-[95%] border rounded-lg mb-4 ">
            <div className="flex items-center p-4">
              <img src={documents_icon} alt="documents" />
              <p className="text-[14px] font-bold ml-4">Documents</p>
            </div>
            <div className="flex">
              <div className="flex border w-[40%] ml-4 rounded-lg p-2 mb-2">
                <img
                  src={attachment_pin_icon}
                  alt="attachment-image"
                  className="w-8 object-contain"
                />
                <div className="ml-4">
                  <div className="text-[16px] font-bold">Whatsapp invite</div>
                  <div className="text-[#91929E] text-[12px]">10 MB PNG</div>
                </div>
              </div>
              <div className="flex border w-[40%] ml-4 rounded-lg p-2 mb-2">
                <img
                  src={attachment_pin_icon}
                  alt="attachment-image"
                  className="w-8 object-contain"
                />
                <div className="ml-4">
                  <div className="text-[16px] font-bold">brochure</div>
                  <div className="text-[#91929E] text-[12px]">10 MB PNG</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminCustomerHistory;
